const transformUploadedImages = images =>
  images
    .filter(image => image.success)
    .map(({ id, originalSizeUrl, thumbnailSizeUrl }) => ({
      id,
      urls: { originalSizeUrl, thumbnailSizeUrl },
    }))

export default transformUploadedImages
